/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const Team = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path
      fillRule="evenodd"
      d="M20 8.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM21.735 19h-6.759c.016-.08.024-.163.024-.25v-5.263c0-.498-.11-.96-.304-1.376a4.84 4.84 0 002.54.712A4.837 4.837 0 0019.946 12c1.14.033 2.053.942 2.053 2.058v4.685a.261.261 0 01-.265.257zM13 14.058V19h.714c.158 0 .286-.112.286-.25v-5.263c0-.359-.086-.7-.24-1.008-.465.377-.76.945-.76 1.58z"
      clipRule="evenodd"
      opacity={0.6}
    />,
    <path
      fillRule="evenodd"
      d="M11 7a3 3 0 11-6 0 3 3 0 016 0zm-3 4.984c1.303 0 2.51-.365 3.494-.984 1.412.152 2.506 1.207 2.506 2.487v5.262c0 .139-.128.251-.286.251H2.286C2.128 19 2 18.888 2 18.75v-5.263c0-1.28 1.094-2.335 2.506-2.487.984.62 2.19.984 3.494.984z"
      clipRule="evenodd"
    />,
  );
};

export default Team;
